import React from "react";

import styled from "styled-components";
import okIcon from "../../assets/images/ico_p_pass.png";
import ngIcon from "../../assets/images/ico_p_ng.png";
import naIcon from "../../assets/images/ico_p_na.png";

export const StyledDiv = styled.div`
  text-align: center;

  table {
    width: 100%;
    margin-bottom: 20px;
  }

  tr {
    border-bottom: 1px solid #d9d9d9;

    &:last-child {
      border-bottom: none;
    }
  }

  th {
    font-size: 16px;
    height: 39px;
    color: #000;
    font-weight: bold;
  }

  td {
    color: #000;
  }

  .ng dd {
    color: #e63312;
  }

  .na dd {
    color: #999;
  }

  .items {
    td {
      height: 370px;
    }

    dl {
      position: relative;
      width: 90px;
      margin: 0 auto;
      padding-right: 42px;

      &:last-child {
        margin-bottom: 0;
      }

      &:after {
        content: "";
        display: inline-block;
        width: 35px;
        height: 35px;
        position: absolute;
        bottom: 4px;
        right: 0;
      }

      &.ok:after {
        background: url(${okIcon}) no-repeat;
      }

      &.ng:after {
        background: url(${ngIcon}) no-repeat;
      }

      &.na:after {
        background: url(${naIcon}) no-repeat;
      }
    }

    dt {
      font-size: 17px;
      margin-bottom: 5px;
    }

    dd {
      background-color: #f6f3f2;
      font-weight: bold;
      font-size: 28px;
      height: 50px;
      line-height: 55px;
    }
  }
`;

const TestDriveDiv = ({ className, children }) => {
  return (
    <StyledDiv className={className}>
      <div>{children}</div>
    </StyledDiv>
  );
};

export default TestDriveDiv;
